import React from 'react';
import styled, { css } from 'styled-components';
import ContentLoader from 'react-content-loader';
import { Icon } from 'components';

export const CartSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

interface CartSummaryItemProps {
  bold?: boolean
}

export const CartSummaryItem = styled.div<CartSummaryItemProps>`
  display: flex;
  justify-content: space-between;
  ${({ bold }) =>
    bold &&
    css`
      p {
        font-weight: bold;
      }
    `}
  p,
  h3 {
    margin: 0.75rem 0;
  }
  button {
    cursor: pointer;
    color: #629eba;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    border: none;
    background-color: #f2f2f2;
    padding: 0;
    margin-left: 10px;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const GiftCardSummaryItem = styled(CartSummaryItem)`
  gap: 10px;

  > p {
    max-width: 11rem;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  button {
    margin-left: 0;
  }
`;

export const CartSummaryGroup = styled.div`
  margin: 0.5rem 0;
  p {
    margin: 0;
  }
  > p {
    margin-bottom: 5px;
  }
`;

const CartSummarySkeletonWrapper = styled.div`
  width: 100%;
  div {
    width: 100%;
    display: flex;
    svg {
      height: 10px;
      width: 75px;
      margin-bottom: 2.6rem;
      &:last-of-type {
        width: 30px;
      }
    }
    svg:nth-last-of-type(2) {
      margin-left: auto;
      width: 12px;
    }
    &:last-of-type {
      margin-bottom: 0;
      svg {
        margin-bottom: 1rem;
      }
    }
  }
`;

export const FreeShippingMessage = styled.div`
box-sizing: border-box;
background: #F9FAF9;
border: 1px solid #000000;
border-radius: 4px;
width: 100%;
padding: 10px 10px 5px 10px;
position: relative;
`;
export const FreeShippingMessageDollars = styled.span`
font-weight: bold;
padding-left: 5px;
`;
export const FreeShippingTagIcon = styled(Icon)`
float: left
`;
export const CartSummarySkeleton = (): React.JSX.Element => (
  <CartSummarySkeletonWrapper data-testid="cart-summary-skeleton">
    <div>
      <ContentLoader speed={0.75} height={10} width={75} />
      <ContentLoader speed={0.75} height={10} width={10} />
      <ContentLoader speed={0.75} height={10} width={30} />
    </div>
    <div>
      <ContentLoader speed={0.75} height={10} width={75} />
      <ContentLoader speed={0.75} height={10} width={10} />
      <ContentLoader speed={0.75} height={10} width={30} />
    </div>
    <div>
      <ContentLoader speed={0.75} height={10} width={75} />
      <ContentLoader speed={0.75} height={10} width={10} />
      <ContentLoader speed={0.75} height={10} width={30} />
    </div>
    <div>
      <ContentLoader speed={0.75} height={10} width={75} />
      <ContentLoader speed={0.75} height={10} width={10} />
      <ContentLoader speed={0.75} height={10} width={30} />
    </div>
  </CartSummarySkeletonWrapper>
);
export const FreeShippingConfirmationText = styled.span`
font-size: 12px;
padding-left: 5px;
`;